export const inFuture = (date: Date, compareTo: Date) => {
  return date.setHours(0, 0, 0, 0) >= compareTo.setHours(0, 0, 0, 0)
}

export const checkAndSetDate = (
  newDate: Date,
  compareTo: Date,
  setDate: any,
  messageOnFailure: string,
) => {
  if (newDate && inFuture(newDate, compareTo)) {
    setDate(newDate)
    return true
  } else {
    messageOnFailure && alert(messageOnFailure)
    setDate(compareTo)
    return false
  }
}

export const addNumberToTimeAndCheck = (
  time: string,
  nNumber: string,
  location: number,
) => {
  let t = time.split('')
  t[location] = nNumber
  let hh = parseInt(t[0] + '' + t[1])
  let mm = parseInt(t[2] + '' + t[3])
  if (hh > 23) hh = 0
  if (mm > 59) mm = 0
  return addDigits(hh, 2) + '' + addDigits(mm, 2)
}

export const addDigits = (number: number, n?: number) => {
  if (n == undefined) n = 2
  return (new Array(n).join('0') + number.toString()).slice(-n)
}

export const isNumber = (char: string) => {
  return /^\d+$/.test(char)
}

export const isArraysHaveCommonStrings = (
  arr1: string[] = [],
  arr2: string[] = [],
) => {
  return arr1.some((item) => arr2.includes(item))
}